import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../redux/network/https';
import { endPoints } from '../../redux/network/constant';

/**
 * Fetch recent activities for the current user
 */
export const useRecentActivities = (limit = 10, days = 30, enabled = true) => {
  return useQuery({
    queryKey: ['activities', 'recent', { limit, days }],
    queryFn: async () => {
      const { data } = await axiosInstance.get(endPoints.RecentActivities, {
        params: { limit, days },
      });
      const payload = data?.data;
      return Array.isArray(payload) ? payload : payload?.results || [];
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });
};
